import { TestDevicesServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/test_devices/Test_devicesServiceClientPb';

import {
  TestDevice,
  CreateRequest,
  CreateResponse,
  ListRequest,
  ListResponse,
  DeleteRequest,
  DeleteResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/test_devices/test_devices_pb';

export type TestDevicesExportClasses = {
  TestDevicesServiceClient: typeof TestDevicesServiceClient,
  TestDevice: typeof TestDevice,
  CreateRequest: typeof CreateRequest,
  CreateResponse: typeof CreateResponse,
  ListRequest: typeof ListRequest,
  ListResponse: typeof ListResponse,
  DeleteRequest: typeof DeleteRequest,
  DeleteResponse: typeof DeleteResponse,
};

export const testDevices: TestDevicesExportClasses = {
  TestDevicesServiceClient,
  TestDevice,
  CreateRequest,
  CreateResponse,
  ListRequest,
  ListResponse,
  DeleteRequest,
  DeleteResponse,
};
